export const CALC_MENU_LIST = {
  "Pressuring	the Opponent": {
    "Frame Trap Checker": {
      url: "frametrapchecker",
      desc: "Check the frame gap between two moves when the first is blocked",
      icon: "bulbOutline",
    },
    "Frame Trap Lister": {
      url: "frametraplister",
      desc: "Provide FAT with a number of frames, and it will generate a list of 2 move strings for you",
      icon: "receiptOutline",
    },
    "Frame Kill Generator": {
      url: "framekillgenerator",
      desc: "Automatically generate frame kills for a selection of oki scenarios",
      icon: "skullOutline",
      excludedGames: ["GGST", "2XKO"],
    },
  },
  "Punishing Moves": {
    "Move Punisher": {
      url: "movepunisher",
      desc: "Find out how to punish a specific move with your character",
      icon: "personRemoveOutline",
    },
    "Character Punisher": {
      url: "characterpunisher",
      desc: "See what your character's move can punish for a specific opponent",
      icon: "peopleOutline",
    },
  },
  Other: {
    "Move Linker": {
      url: "movelinker",
      desc: "See what a selected move can link to",
      icon: "linkOutline",
    },
    "String Interrupter": {
      url: "stringinterrupter",
      desc: "Figure out what moves you can push during a specific blockstring",
      icon: "handLeftOutline",
    },
  },
};

export const RES_MENU_LIST = {
  Discords: {
    url: "discords",
    desc: "Find communities for beginners, specific characters, and more",
    icon: "logoDiscord",
  },
  Apps: {
    url: "apps",
    desc: "Find out about what else is out there to help you become a master",
    icon: "desktopOutline",
  },
  "Wikis, Docs & Sheets": {
    url: "docs",
    desc: "Check out all the incredible and in depth docs and wikis there are",
    icon: "documentTextOutline",
  },
  "Social Media": {
    url: "social",
    desc: "Some of the best resources are on Youtube and Bluesky, check em out!",
    icon: "chatbubblesOutline",
  },
  "FAT Team": {
    url: "fat",
    desc: "The team that brought you this very app!",
    icon: "heartOutline",
  },
};

export const RES_DISCORDS_LIST = {
  "Community Discords": {
    game: "any",
    data: {
      "New Challenger": {
        desc: "A great place for new players to find a coach or mentor and also just a good place to find games",
        url: "https://discord.gg/NewChallenger",
      },
      "FAT Chat": {
        desc: "The best place to report bugs and data problems, and also an unoffical FGC programmers hang out",
        url: "https://discord.gg/b82QP4VMPK",
      },
    },
  },
  "SF6 Resource Hub Discord": {
    game: "SF6",
    data: {
      "SF6 Resource Hub": {
        desc: "The central spot to discuss SF6",
        url: "https://discord.gg/sf6hub",
      },
    },
  },
  "SFV Character Discords": {
    game: "SFV",
    data: {
      Abigail: {
        url: "https://discord.gg/hrmVyMF",
      },
      Akira: {
        url: "https://discord.gg/Es2W8zC",
      },
      Akuma: {
        url: "https://discord.gg/cVXAwnN",
      },
      Alex: {
        url: "https://discord.gg/0sIp7XoPqUJK5hj9",
      },
      Balrog: {
        url: "https://discord.gg/JqaUCE6",
      },
      Birdie: {
        url: "https://discord.com/invite/Xxu6QNT",
      },
      Blanka: {
        url: "https://discord.com/invite/XzHkn6N",
      },
      Cammy: {
        url: "https://discord.com/invite/0pgjU35fSAeJNlCQ",
      },
      "Chun-Li": {
        url: "https://discord.com/invite/nDFhUjM",
      },
      Cody: {
        url: "https://discord.com/invite/mgdJxH6",
      },
      Dan: {
        url: "https://discord.com/invite/6sPysB9",
      },
      Dhalsim: {
        url: "https://discord.com/invite/0pw1HkuKuIcoL8th",
      },
      Ed: {
        url: "https://discord.com/invite/JEqx5R5",
      },
      "E.Honda": {
        url: "https://discord.com/invite/a8WFtaR",
      },
      Falke: {
        url: "https://discord.com/invite/cBZrPhd",
      },
      "F.A.N.G": {
        url: "https://discord.com/invite/0pDFIU0b3AAWuCLB",
      },
      G: {
        url: "https://discord.com/invite/k6gdFwW",
      },
      Gill: {
        url: "https://discord.com/invite/wURBaQ7",
      },
      Guile: {
        url: "https://discord.com/invite/cjNx4up",
      },
      Ibuki: {
        url: "https://discord.com/invite/012ePpX8MjyCsPmWz",
      },
      Juri: {
        url: "https://discord.com/invite/8Xs5ddd",
      },
      Kage: {
        url: "https://discord.com/invite/kH5ZMqY",
      },
      Karin: {
        url: "https://discord.com/invite/0pqKU7KdtVj0Nymo",
      },
      Ken: {
        url: "https://discord.com/invite/jVNdP3j",
      },
      Kolin: {
        url: "https://discord.com/invite/ZFtFUcu",
      },
      Laura: {
        url: "https://discord.com/invite/0pgnkd5WoeGroSto",
      },
      Lucia: {
        url: "https://discord.com/invite/N89CwzY",
      },
      "M. Bison": {
        url: "https://discord.com/invite/0qStOBEBl8pEdFTC",
      },
      Menat: {
        url: "https://discord.com/invite/JmjvFbw",
      },
      Nash: {
        url: "https://discord.com/invite/EgKYgam",
      },
      Necalli: {
        url: "https://discord.com/invite/0qSupGuWRMVBcfph",
      },
      Oro: {
        url: "https://discord.com/invite/yjSaedG",
      },
      Poison: {
        url: "https://discord.com/invite/QV77zFs",
      },
      Rashid: {
        url: "https://discord.com/invite/0proOqVUwUKFoPgz",
      },
      "R. Mika": {
        url: "https://discord.com/invite/npnyWeT",
      },
      Rose: {
        url: "https://discord.com/invite/PRM9ypfBGC",
      },
      Ryu: {
        url: "https://discord.com/invite/0r4LbtufVq0WdPSG",
      },
      Sagat: {
        url: "https://discord.com/invite/tXa4PdV",
      },
      Sakura: {
        url: "https://discord.com/invite/QRztyhd",
      },
      Seth: {
        url: "https://discord.com/invite/zMFCTej",
      },
      Urien: {
        url: "https://discord.com/invite/92saMnK",
      },
      Vega: {
        url: "https://discord.com/invite/0q46RfKOwYGosACt",
      },
      Zangief: {
        url: "https://discord.com/invite/0pyTHFGvV3sA7QGX",
      },
      Zeku: {
        url: "https://discord.com/invite/DhJhAja",
      },
    },
  },
  "GGST Character Discords": {
    game: "GGST",
    data: {
      Anji: {
        url: "https://discord.com/invite/QNertwjTbT",
      },
      Asuka: {
        url: "https://discord.com/invite/rgQ4HH74AQ",
      },
      Axl: {
        url: "https://discord.com/invite/Jmykxqw",
      },
      Baiken: {
        url: "https://discord.com/invite/pwF4pC3",
      },
      Bedman: {
        url: "https://discord.com/invite/TTWraKdraG",
      },
      Bridget: {
        url: "https://discord.com/invite/5WD2yxfrGb",
      },
      Chipp: {
        url: "https://discord.com/invite/vgjNgxYNPN",
      },
      Faust: {
        url: "https://discord.com/invite/8K3FX7cHat",
      },
      Giovanna: {
        url: "?",
      },
      Goldlewis: {
        url: "https://discord.com/invite/XC8ZRHebtC",
      },
      "H. Chaos": {
        url: "https://discord.com/invite/Xfzd7mkamF",
      },
      "I-No": {
        url: "https://discord.com/invite/bJv9ZD8ZPf",
      },
      "Jack-O": {
        url: "https://discord.com/invite/4WRSEsaPMW",
      },
      Ky: {
        url: "https://discord.com/invite/HSEbnjrCYt",
      },
      Leo: {
        url: "https://discord.com/invite/3WdB3qXP7K",
      },
      May: {
        url: "https://discord.com/invite/0TarBXRJrjkn08Ln",
      },
      Millia: {
        url: "https://discord.com/invite/uJKdbx6TdP",
      },
      Nagoriyuki: {
        url: "https://discord.com/invite/6SVCgZwF7R",
      },
      Potemkin: {
        url: "https://discord.com/invite/e26ZQmDeny",
      },
      Ramlethal: {
        url: "https://discord.com/invite/vHKAwFjES6",
      },
      Sin: {
        url: "https://discord.com/invite/c29MewwcD5",
      },
      Sol: {
        url: "?",
      },
      Testament: {
        url: "https://discord.com/invite/QZEHkcfCXf",
      },
      "Zato-1": {
        url: "https://discord.com/invite/fKS9CRXJrt",
      },
    },
  },
};

export const RES_APPS_LIST = {
  "General Resources": {
    game: "any",
    data: {
      "FAT Online": {
        desc: "A desktop version of FAT",
        url: "https://fullmeter.com/fatonline",
      },
      "FAT Draft": {
        desc: "Multiplayer random select with strategy! Connect with a friend and ban/pick characters",
        url: "https://fullmeter.com/fatdraft",
      },
      Yaksha: {
        desc: "An excellent SFV & SF6 frame data Discord bot",
        url: "https://github.com/ellipses/Yaksha",
      },
    },
  },
  "SFV PC Stuff": {
    game: "SFV",
    data: {
      FrameTrapped: {
        desc: "A hit box viewer which makes in depth labbing so much easier",
        url: "https://frametrapped.com/",
      },
      "SFV Sim": {
        desc: "An in browser SFV interaction emulator. Use it to test specific situations",
        url: "https://sfvsim.com/",
      },
      "SFV Diff": {
        desc: "Check what changed in SFV's files between patches",
        url: "https://sfvsim.com/diff/",
      },
      "Mysterious Mod": {
        desc: "???",
        url: "https://github.com/MMKillbox/MysteriousMod",
      },
    },
  },
  "SF6 PC Stuff": {
    game: "SF6",
    data: {
      "SF6 Hitbox Viewer": {
        desc: "A hit box viewer which makes in depth labbing so much easier",
        url: "https://github.com/WistfulHopes/SF6Mods/releases/tag/hitboxes-1.0.1",
      },
      "SF6 Sim": {
        desc: "An in browser SF6 interaction emulator. Use it to test specific situations",
        url: "https://wistfulhopes.github.io/sf6_sim/",
      },
    },
  },
  "GGST PC Stuff": {
    game: "GGST",
    data: {
      "GGST Hitbox Viewer": {
        desc: "A hit box viewer which makes in depth labbing so much easier",
        url: "https://github.com/WistfulHopes/StriveHitboxes-UML",
      },
    },
  },
};

export const RES_DOCS_LIST = {
  "General Wikis, Docs & Sheets": {
    game: "any",
    data: {
      "Gief's Gym": {
        desc: "A full book about learning SFV written by SuperJoeMonday",
        url: "https://www.reddit.com/r/streetfighter/wiki/v/giefsgym",
      },
      "FGC Map": {
        desc: "It's a little out of date, but this map is the best place to start when looking for your local FGC",
        url: "https://www.google.com/maps/d/viewer?mid=1CepQmeYS81xE9yY4RhbwBmiYTAg&ll=55.01601711300589%2C-4.6732604575443295&z=6",
      },
    },
  },
  "SFV Wikis, Docs & Sheets": {
    game: "SFV",
    data: {
      "FAT SFV Spreadsheet": {
        desc: "This is the document that we use to compile the SFV data",
        url: "https://docs.google.com/spreadsheets/d/1nlbWon7SYhhO5TSpNx06qQrw2TRDEZ85HQrNherXioY/",
      },
      "Sestze's SFV Starter Doc": {
        desc: "An absolutely amazing doc and the source of the great combos & tech mode in this app",
        url: "https://docs.google.com/spreadsheets/d/1T9CdiurUdmwAscuGOu_B0dB3IInBr5ksFk1VSGnk5uY/edit#gid=0",
      },
      "NCH SFV Resource Compilation": {
        desc: "An incredible resource for SFV which includes everything from SFV strategy to FG philosophy",
        url: "https://docs.google.com/spreadsheets/d/173DjkfbRPCpb86mI3l0C_9nDRHCEfMiDzjc6hPDrn1E/edit#gid=0",
      },
      "Supercombo Wiki": {
        desc: "The Super Combo Wiki hosts frame data and more, for a ton of Fighting Games. They also use the FAT data for SFV!",
        url: "https://wiki.supercombo.gg/",
      },
    },
  },
  "SF6 Wikis, Docs & Sheets": {
    game: "SF6",
    data: {
      "FAT SF6 Spreadsheet": {
        desc: "This is the document that we use to compile the SF6 data",
        url: "https://docs.google.com/spreadsheets/d/1JncPFer0RELkKvA9boqHzZ7SqvqTNiX9QLOy9QKzEOM/",
      },
      "Sestze's SF6 Starter Doc": {
        desc: "An absolutely amazing doc and the source of the great combos & tech mode in this app",
        url: "https://docs.google.com/spreadsheets/d/1L5hQoTEwKF20IFExQnthy9nVeB23CRuXVplkryvrOKU/edit#gid=0",
      },
      "NCH SF6 Resource Compilation": {
        desc: "An incredible resource for SF6 which includes everything from SF6 strategy to FG philosophy",
        url: "https://docs.google.com/spreadsheets/d/1xih9qc_tKMf1e2Y-zFvGkDpR2j2xPLW2ruBTn1d75hI/edit#gid=692754923",
      },
      "Supercombo Wiki": {
        desc: "The Super Combo Wiki hosts frame data and more, for a ton of Fighting Games.",
        url: "https://wiki.supercombo.gg/",
      },
    },
  },
  "GGST Wikis, Docs & Sheets": {
    game: "GGST",
    data: {
      "FAT GGST Spreadsheet": {
        desc: "This is the document that we use to compile the GGST data",
        url: "https://docs.google.com/spreadsheets/d/1gEDhZ-_N5VSKJiPm3g1lbWpo1iuaxnfdRupYavHWNNE/",
      },
      "NCH GGST Resource Compilation": {
        desc: "As above, but for GGST!",
        url: "https://docs.google.com/spreadsheets/d/1fHNTtZMIceVZvOcfEWIqMjd7vekwmnnY51ot9QgldvY/edit#gid=0",
      },
      Dustloop: {
        desc: "Dustloop is a massive resource for all ArcSys games, not just GGST. Check it out!",
        url: "https://dustloop.com",
      },
    },
  },
};

export const RES_SOC_LIST = {
  Bluesky: {
    game: "any",
    data: {
      "FAT Updates": {
        desc: "Keep up to date with what I'm working on, or pester me to add a feature",
        url: "https://bsky.app/profile/d4rkonion.bsky.social",
      },
      HiFight: {
        desc: "Lots of interesting tech and clips from recent CPT events",
        url: "https://bsky.app/profile/hifight.bsky.social",
      },
      Hatson: {
        desc: "Hatson posts lots of cool tech, and he works on the data for FAT!",
        url: "https://bsky.app/profile/hatson.bsky.social",
      },
    },
  },
  Youtube: {
    game: "any",
    data: {
      Sajam: {
        desc: "A fantastic channel for keeping up to date on FGC news and new games",
        url: "https://www.youtube.com/user/SupermanSajam",
      },
      "Theory Fighter": {
        desc: "In depth video essays about specific mechanics in Fighting Games. Bonus points if you like Doom Music",
        url: "https://www.youtube.com/user/TheoryFighter",
      },
      Brian_F: {
        desc: "Thoughtful discussions, beginner content, and indepth analysis; Brian_F's got it all",
        url: "https://www.youtube.com/channel/UCKXApalBm-SpCgX9TAkyOuQ?cbrd=1",
      },
      "Core-A Gaming": {
        desc: "Excellent video essays about general Fighting Game topics",
        url: "https://www.youtube.com/channel/UCT7njg__VOy3n-SvXemDHvg",
      },
      "JoJo's Quick SFV Guides": {
        desc: "Great playlist of 7 quick videos to get you started in SFV",
        url: "https://www.youtube.com/playlist?list=PLQ48YTtcvkJNCsu7L7mkILh1HCcLYcKpt",
      },
      UltraChenTV: {
        desc: "For as long as there has been FGC, there has been James Chen and Ultradavid",
        url: "https://www.youtube.com/channel/UCwmE_eVPPvQ4bjJqguhyUcg",
      },
    },
  },
};

export const RES_FAT_LIST = {
  "App Development": {
    game: "any",
    data: {
      "D4RK ONION": {
        desc: "That's me! I do 100% of the coding on FAT so when it breaks that means it's my fault. Yay!",
        url: "https://bsky.app/profile/d4rkonion.bsky.social",
      },
      Jupli: {
        desc: "My friend Gary who does the iOS release and answers my many questions. Thank god it's free, I couldn't afford him.",
        url: "https://bsky.app/profile/jupli.com",
      },
    },
  },
  "Frame Data Team": {
    game: "any",
    data: {
      Hatson: {
        desc: "Hatson single handedly carried the app on his back for years by updating and adding new characters",
        url: "https://bsky.app/profile/hatson.bsky.social",
      },
      adam: {
        desc: "He's a Urien player, but don't let that put you off, adam did a ton of work on the SFV: CE update and beyond (and no, I haven't typo'd his name)",
        url: "https://bsky.app/profile/adam5522.bsky.social",
      },
      MonkUnit: {
        desc: "Our newest SFV frame data member, MonkUnit did a mammoth amount of work adding Hit Confirm Windows to the app!",
        url: "https://bsky.app/profile/monkunit.bsky.social",
      },
      Arlieth: {
        desc: "Arlieth was the first person to help me with the frame data spreadsheet and continues to help out today!",
        url: "https://bsky.app/profile/arlieth.com",
      },
      Jojo: {
        desc: "You might know JoJo for his extensive beginner spreadsheets for SFV and GGST. He's put in a huge amount of work testing, homogenising and fleshing out the GGST data",
        url: "https://bsky.app/profile/nchjojo.bsky.social",
      },
    },    
  },
};